<template>
	<div id="tag-list-block">
		<TagList
			:tag-icon-visible="!isMobileWebApp"
			:checkbox-always-visible="isMobileWebApp"
			@edit="handleMultipleEdit"
			@share="handleShare"
		/>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import TagList from '@js/analysis/components/TagList/TagList';

export default {
	name:       'TagListBlock',
	components: {
		TagList,
	},
	data() {
		return {
			tagFilters: [],
		};
	},
	computed: {
		...mapGetters({
			isMobileWebApp: 'app/isMobileWebApp',
		}),
	},
	watch: {
		filterOptions: function(newFilterOptions) {
			this.tagFilters = this.tagFilters.filter(tagFilter => {
				return newFilterOptions.find(filterOption => filterOption.value.id === tagFilter.id);
			});
		},
	},
	methods: {
		...mapActions({
			editEventTag:      'eventTagEdit/editEventTag',
			bulkEditEventTags: 'eventTagEdit/bulkEditEventTags',
		}),
		handleMultipleEdit(items) {
			if (items.length === 1) {
				this.editEventTag(items[0].tag);
			} else {
				this.bulkEditEventTags(items.map(item => item.tag));
			}
		},
		handleShare(item) {
			this.$emit(
				'share',
				this.tags.find((e) => e.id === item.id)
			);
		},
	},
};
</script>

<style lang="scss" scoped>
#tag-list-block {
	height: 100%;
}
</style>
